module.exports = __webpack_public_path__ + "img/UsersPersonalData.a2dc30f9.svg";